import React from "react";
import PropTypes from "prop-types";
import styles from "./Contact.css";

const contact = ({ display }) => {
  let displayClass = [styles.Contact, styles.ContactActive];
  if (!display) {
    displayClass = [styles.Contact, styles.ContactHidden];
  }

  return (
    <div className={displayClass.join(" ")}>
      <h1>Contact</h1>
      <h3>Contact coming soon!</h3>
    </div>
  );
};

contact.propTypes = {
  display: PropTypes.bool.isRequired
};

export default contact;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Contact/Contact.js